// import external dependencies

export let elements = {};

export function setup(element) {
  elements.root = $(element);

  elements.slides = elements.root.find('.list__step');
  elements.navigation = elements.root.find('.list__step-link');
}

export function changeSlide(selectClass) {
  const currentSlide = elements.slides.filter('.active');
  const activeSlide = elements.slides.filter('.' + selectClass);
  if(currentSlide[0]) {
    currentSlide.fadeOut(250, () => {
      elements.slides.removeClass('active');
      activeSlide.addClass('active');
      activeSlide.css({ opacity: 0, display: 'block' }).animate({ opacity: 1 }, 250);
    });
  } else {
    activeSlide.addClass('active');
    activeSlide.css({ opacity: 0, display: 'block' }).animate({ opacity: 1 }, 250);
  }

  elements.navigation.removeClass('active');
  let activeNav = elements.navigation.children('a[data-slide="' + selectClass + '"]');
  activeNav.parent().addClass('active');

  return activeSlide[0];
}
